import { User } from "@types";

import { isEmpty } from "lodash";
import { Role } from "@constants/roles";

export const getSharedLink = (user: User) => {
  const { shared_links, role } = user || {};

  if (!user || isEmpty(shared_links) || role !== Role.OPEN_LINK) {
    return null;
  }

  const { host, href } = window.location;

  let link = shared_links.find(({ url }) => url === href);

  if (!link) {
    link = shared_links.find(({ url }) => url.includes(host));
  }

  if (!link) {
    return null;
  }

  const parts = link.url.split(window.location.host);

  return `${parts[1]}`;
};
